import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	ddnyTitle,
} from '../../../../utils/ddny';

import LoadingIcon from '../../../common/icons/LoadingIcon';
import ProductSelector from './ProductSelector';
import RhinoConfirm from '../../../common/confirm/RhinoConfirm';

import styles from './_styles/RelatedItemEdit.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class RelatedItemEdit extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {

			selectedItem: this.props.item?.related_product || null,
			selectedItemOpen: false,

			inputLabel: this.props.item?.label || '',
			inputReverseLabel: this.props.item?.reverse_relation?.label || '',

			errorLabel: '',
			errorReverseLabel: '',
			errorSelectedItem: '',

			requestPending: false,
			requestError: '',

			deletePromptOpen: false,
		};
	}

	getItemError(item = null) {

		const selectedItem = item || this.state.selectedItem;
		
		// Cannot be related to itself
		if(selectedItem?.id === this.props.product?.id) {
			return 'Cannot relate a product to itself';
		}
		
		// Relation already exists
		for(const ri of this.props.product?.related_items) {
			// if(vnt.gold_color === this.metalColor() && vnt.gold_weight === this.metalWeight()) {
			// 	return true;
			// }
		}
		return '';
	}

	async handleSubmit(evt) {
		if(evt) { evt.preventDefault(); }

		const itemError = this.getItemError();
		if(itemError) {
			this.setState({ requestError: itemError });
			return;
		}

		const v0 = this.validateLabel();
		const v1 = this.validateReverseLabel();

		if(v0 && v1) {
			
			this.setState({
				requestPending: true,
				requestError: '',
			});

			try {

				const relatedItemData = {
					product_id: this.props.product.id,
					item_id: this.state.selectedItem?.id,
				}
				if(this.state.inputLabel) {
					relatedItemData['label'] = this.state.inputLabel;
				}
				if(this.state.inputReverseLabel) {
					relatedItemData['reverse_label'] = this.state.inputReverseLabel;
				}

				this.props.item
					?	 await this.props.ddnyUpdateRelatedItem(this.props.item.id, relatedItemData)
					:	 await this.props.ddnyCreateRelatedItem(relatedItemData);
			
				await this.props.refresh({ showLoading: false });

				this.props.closeAction();

			} catch(err) {
				this.setState({
					requestPending: false,
					requestError: err.msg || 'An unexpected error has occurred',
				})
			}
		}
	}

	async handleDelete() {

		this.setState({
			requestPending: true,
			requestError: '',
		});

		try {

			await this.props.ddnyDeleteRelatedItem(this.props.item.id);
		
			await this.props.refresh({ showLoading: false });

			this.props.closeAction();

		} catch(err) {
			this.setState({
				requestPending: false,
				requestError: err.msg || 'An unexpected error has occurred',
			})
		}
	}

	changeLabel(evt) {
		this.setState({ 
			inputLabel: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorLabel) {
				this.validateLabel();
			}
		});
	}

	validateLabel() {
		if(this.state.errorLabel?.length > 100) {
			this.setState({ errorLabel: 'Label must be less than 100 characters' });
			return false;
		}
		this.setState({ errorLabel: '' });
		return true;
	}

	changeReverseLabel(evt) {
		this.setState({ 
			inputReverseLabel: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorReverseLabel) {
				this.validateReverseLabel();
			}
		});
	}

	validateReverseLabel() {
		if(this.state.errorReverseLabel?.length > 100) {
			this.setState({ errorReverseLabel: 'Label must be less than 100 characters' });
			return false;
		}
		this.setState({ errorReverseLabel: '' });
		return true;
	}

	setSelectedItem(item) {

		const itemError = this.getItemError(item);

		if(itemError) {
			this.setState({
				selectedItem: null,
				selectedItemOpen: false,
				errorSelectedItem: itemError,
			});
		} else {
			this.setState({
				selectedItem: item,
				selectedItemOpen: false,
				errorSelectedItem: '',
			});
		}
	}

	changeItem() {
		this.setState({
			selectedItemOpen: true,
			errorSelectedItem: '',
		});
	}

	cancelItem() {
		this.setState({
			selectedItemOpen: false,
			errorSelectedItem: this.getItemError(),
		});
	}
	
	render() {
		return <div className={`${styles.RelatedItemEdit}`}>
			<div className={styles.titleSection}>
				<div className={styles.title}>Edit Related Item</div>
			</div>

			{this.state.requestError && (
				<div className={styles.errorSection}>{this.state.requestError}</div>
			)}

			<div className={styles.itemSection}>
				<div className={styles.itemWrapper}>
					<div className={styles.itemLabel}>
						<div className={styles.label}>Related Item</div>
						
						{(this.state.selectedItem && !this.state.selectedItemOpen) && (
							<div className={styles.action} onClick={this.changeItem.bind(this)}>
								Change
							</div>
						)}

						{(this.state.selectedItem && this.state.selectedItemOpen) && (
							<div className={styles.action} onClick={this.cancelItem.bind(this)}>
								Cancel
							</div>
						)}
						
					</div>
					<div className={styles.itemSelectionWrapper}>
						
						{(this.state.selectedItem && !this.state.selectedItemOpen) ? (
							<div className={styles.itemSelected}>
								<div className={styles.displayWrapper}>
									<div className={styles.title}>{ddnyTitle(this.state.selectedItem)}</div>
									{this.state.selectedItem?.sku && (
										<div className={styles.sku}>{this.state.selectedItem.sku}</div>
									)}
								</div>
							</div>										
						) : (
							<div className={styles.itemPlaceholder}>
								<ProductSelector
									onSelect={this.setSelectedItem.bind(this)}
									currentSelection={this.state.selectedItem} />
							</div>
						)}

						{this.state.errorSelectedItem && (
							<div className={styles.itemError}>
								{this.state.errorSelectedItem}
							</div>
						)}

					</div>
				</div>
			</div>

			<div className={styles.inputSection}>
				<div className={styles.inputBlock}>
					<div className={`${styles.label} EllipsisElement`}>Label</div>
					<div className={styles.inputElement}>
						<input
							className={this.state.errorLabel ? styles.error : ''}
							value={this.state.inputLabel}
							onChange={this.changeLabel.bind(this)}
							onBlur={this.validateLabel.bind(this)}
							placeholder='Optional' />
						{this.state.errorLabel && (
							<div className={styles.inputError}>{this.state.errorLabel}</div>
						)}
					</div>
				</div>
				<div className={styles.inputBlock}>
					<div className={`${styles.label} EllipsisElement`}> Reverse Label</div>
					<div className={styles.inputElement}>
						<input
							className={this.state.errorReverseLabel ? styles.error : ''}
							value={this.state.inputReverseLabel}
							onChange={this.changeReverseLabel.bind(this)}
							onBlur={this.validateReverseLabel.bind(this)}
							placeholder='Optional' />
						{this.state.errorReverseLabel && (
							<div className={styles.inputError}>{this.state.errorReverseLabel}</div>
						)}
					</div>
				</div>

				{this.state.requestPending && (
					<div className={styles.loadingOverlay}>
						<div className={styles.loadingIcon}>
							<LoadingIcon />
						</div>
					</div>
				)}

			</div>

			<div className={styles.actionSection}>
				<button 
					type='button'
					className={`${styles.action} ${styles.actionLeft} warningButton`} 
					disabled={this.state.requestPending}
					onClick={() => this.setState({ deletePromptOpen: true })}>
					Remove
				</button>
				<button 
					type='button'
					className={`${styles.action} secondaryButton`} 
					disabled={this.state.requestPending}
					onClick={() => this.props.closeAction()}>
					Cancel
				</button>
				<button 
					type='button'
					className={`${styles.action} actionButton`} 
					disabled={this.state.requestPending || !this.state.selectedItem}
					onClick={this.handleSubmit.bind(this)}>
					Save
				</button>
			</div>
			<RhinoConfirm
				confirmTitle='Remove?'
				confirmText='Are you sure you want to remove this related item?'
				confirmButtonName={'Remove'}
				confirmClassName={'warning'}
				confirmMethod={this.handleDelete.bind(this)}
				cancelMethod={() => this.setState({ deletePromptOpen: false })}
				open={this.state.deletePromptOpen} />
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(RelatedItemEdit);